import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ProviderRegistration } from '@shipstation/connections-ui';
import { DirectCarrierRegistration } from '@shipstation/connections-ui/direct';
import { noop } from 'ui-components/default-props/noop';

import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';
import { useEnableDirectModeCarriers } from '../feature-flags/hooks/use-enable-direct-mode-carriers';
import { useCommonCuiProps } from './helpers/use-common-cui-props';

export const CuiProviderRegistration = ({
  providerApiCode,
  providerType,
  onBack = noop,
  onRegisterSuccess = noop,
  onRegisterFailure = noop,
  onError = noop,
  onCancel = noop,
}) => {
  const isDirectMode = useEnableDirectModeCarriers();
  const commonCuiProps = useCommonCuiProps();
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const directContextProps = useMemo(
    () => ({
      ...cuiContextProps,
      onBack,
      onCancel,
      onError,
      onRegisterFailure,
      onRegisterSubmitRedirectForm: onRegisterSuccess, // used by canada post
      onRegisterSuccess,
    }),
    [cuiContextProps, onBack, onCancel, onError, onRegisterFailure, onRegisterSuccess],
  );

  if (isDirectMode) {
    return (
      <DirectCarrierRegistration
        apiConfig={cuiApiConfig}
        contextProps={directContextProps}
        providerApiCode={providerApiCode}
        providerType={providerType}
      />
    );
  }

  return (
    <ProviderRegistration
      {...commonCuiProps}
      onBack={onBack}
      onCancel={onCancel}
      onError={onError}
      onRegisterFailure={onRegisterFailure}
      onRegisterSubmitRedirectForm={onRegisterSuccess} // used by canada post
      onRegisterSuccess={onRegisterSuccess}
      providerApiCode={providerApiCode}
      providerType={providerType}
    />
  );
};

CuiProviderRegistration.propTypes = {
  providerApiCode: PropTypes.string.isRequired,
  providerType: PropTypes.string.isRequired,
  onRegisterSuccess: PropTypes.func,
  onRegisterFailure: PropTypes.func,
  onBack: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
};
